import TakeawaySummary from '../../components/scenes/TakeawaySummary'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import * as basketActions from '../../actions/components/basket'
import * as userActions from '../../actions/components/user'
import { bindActionCreators } from 'redux'
import { injectStripe } from 'react-stripe-elements'
import * as takeawayWaitingBasketActions from '../../actions/components/takeawayWaitingBasket'

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    user: state.user,
    basket: state.basket,
    discount: state.basket.discount,
    form: state.form,
  }
}
const mapDispatchToProps = (dispatch) => {
  const { getRecentPaymentInfo, updatePromoCode } = bindActionCreators(basketActions, dispatch)
  const { setTakeawayWaitingBasket } = bindActionCreators(takeawayWaitingBasketActions, dispatch)

  return {
    getRecentPaymentInfo,
    updatePromoCode,
    setTakeawayWaitingBasket,
    ...bindActionCreators(userActions, dispatch),
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectStripe(injectIntl(TakeawaySummary))))



// WEBPACK FOOTER //
// ./src/containers/scenes/TakeawaySummary.js